export default (x => () => x);